<template>
  <path pid="0" d="M4.52 23.05h17a3 3 0 002.58-4.5L15.57 4.4a3 3 0 00-5.14 0L2 18.54a3 3 0 002.56 4.51zm-.83-3.5l8.46-14.12a1 1 0 011.7 0l8.47 14.14a1 1 0 01-.86 1.48H4.53a1 1 0 01-.85-.5 1 1 0 01.01-1z"/>
</template>
